<template lang="html">
    <div class="member-img" v-bind:style="{ backgroundImage: 'url(' + 'https://www.fotografi-cameramani.ro/upload/useri_echipa/fotografie/photo/' + photo + ')' }">
    </div>
</template>

<script>
export default {
    name: 'MemberPhoto',
    components: {
    },
    props: {
        photo: ''
    },
    computed: {
    },
    data: function() {
        return {}
    },
    mounted() {
    },
    methods: {
    }
}
</script>

<style lang="scss" scoped>

.member-img {
    width: 100%;
    background-size: cover;
    border-radius: 50%;
    display: inline-block;
    vertical-align: middle;

    &:after {
        content: "";
        display: block;
        padding-bottom: 100%;
    }
}

</style>
